import React from "react";

export const headerData_about = [
    {title_kr : '회사개요' , title_en : 'Overview' , url : '/about/overView'},
    {title_kr : '연혁' , title_en : 'History' , url : '/about/history'},
    {title_kr : '수출현황' , title_en : 'Export status' , url : '/about/exportStatus'},
    {title_kr : '사업장소개' , title_en : 'Location' , url : '/about/business'},
]

export const headerData_liebherr = [
    {title_kr : '선박용 엔진', title_en : 'Marine Engine', url : '/liebherr/marineEngine'},
    {title_kr : '발전기 엔진', title_en : 'Generator Engine', url : '/liebherr/generatorEngine'},
]

export const headerData_hyundai = [
    {title_kr : '선박용 엔진', title_en : 'Marine Engine', url : '/hyundai/marineEngine'},
    {title_kr : '발전기 엔진', title_en : 'Generator Engine', url : '/hyundai/generatorEngine'},
]

export const headerData_engineStatus = [
    {title_kr : '설비현황', title_en : 'Facility status', url : '/equipmentStatus'}
]

export const headerData_promotion = [
    {title_kr : '보도자료', title_en : 'Press Release', url : '/prCenter/news?type=ALL'},
    {title_kr : '기술자료', title_en : 'Tech Release', url : '/prCenter/technology?page=1'},
    {title_kr : '홍보자료', title_en : 'Promotion Release', url : '/prCenter/promotion/catalogue?page=1'},
]

export const headerData_contactUs = [
    {title_kr : '문의하기', title_en : 'Contact Us', url : '/contact/inquiry'},
    {title_kr : 'FAQ', title_en : 'FAQ', url : '/contact/faq'},
]

